module.exports = __webpack_public_path__ + "static/media/14Ocurriounerror-14.67d40aa5.png";